import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueMasonry from 'vue-masonry-css'
import './assets/css/reset.css'
import './assets/css/layout.scss'
import './assets/css/page.scss'
import http from './api/index.js'
import VCalendar from 'v-calendar';

Vue.config.productionTip = false
Vue.use(VueMasonry);
Vue.use(VCalendar);

Vue.prototype.$http = http;

// 앱 부트스트랩 함수
async function bootstrap() {
  try {
    // 웹 최초 진입 시 1회 호출
    await store.dispatch('fetchSeasonConfig');
  } catch (e) {
    console.error('시즌 설정 로드 실패:', e);
  }

  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app');
}

// 실행
bootstrap();
